import { Box, styled } from '@/shared/ui';

interface FullscreenLayoutProps {
  $fullscreen?: boolean;
}

export const StyledLayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.custom.grey7,
}));

export const StyledNavBlock = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledContentBlock = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$fullscreen',
})<FullscreenLayoutProps>(({ theme, $fullscreen = false }) => ({
  flexGrow: 1,
  backgroundColor: $fullscreen ? '#F5F7FA' : theme.palette.custom.grey7,
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflow: 'hidden',
}));

export const StyledContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  minHeight: '100vh',
}));

export const StyledHeaderBox = styled(Box)(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 10,
  flexShrink: 0,
  backgroundColor: 'inherit',
}));

export const StyledMainBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$fullscreen',
})<FullscreenLayoutProps>(({ $fullscreen = false }) => ({
  flexGrow: 1,
  overflow: $fullscreen ? 'hidden' : 'auto',
  padding: $fullscreen ? 0 : '20px',
  minHeight: 0,
  minWidth: 0,
}));
